export enum ContentCategories {
    other = 'Другое',
    family = 'Дети, семья',
    design = 'Дизайн',
    cinema = 'Кино и театр',
    dancingAndMusic = 'Музыка и танцы',
    religion = 'Религия',
}
export enum CampaignScheduleStatus {
    VERIFICATION_PENDING = 'verification_pending',
    USER_VERIFICATION_PENDING = 'user_verification_pending',
    DECLINED = 'declined',
    APPROVED = 'approved',
    SCHEDULED = 'scheduled',
    PUBLISHED = 'published',
    FINISHED = 'finished',
    FAILED = 'failed',
    CANCELLED = 'cancelled',
    STOPPED = 'stopped',
    STOP_PENDING = 'stop_pending',
    DRAFT = 'draft',
    Finalized = 'finalized',
}
export enum PublicationStatus {
    Draft = "draft",
    Finalized = "finalized",
    Scheduled = "scheduled",
    InProgress = "in_progress",
    Stopped = "stopped",
    StopPending = "stop_pending",
    Finished = "finished",
    Failed = "failed",
    Cancelled = "cancelled",
}
export enum TransferChannelStatus {
    Active = 'active',
    Inactive = 'inactive',
    VerificationPending = 'verification_pending',
    Suspended = 'suspended',
}